import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './pages/App';
import NotFoundPage from './pages/NotFoundPage';

const RouteSwitch = () => {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<App />}/>
        <Route path="instance/:id" element={<App />}/>
        <Route path="instance/modal/:id" element={<App />}/>
        <Route path="*" element={<NotFoundPage />}/>
      </Routes>
    </>
  );
}

const Router = () => {
  return (
    <BrowserRouter>
      <RouteSwitch />
    </BrowserRouter>
  );
};

export default Router;
